module.exports = __webpack_public_path__ + "assets/img/driver-btn-52adbdf9.png";